<template>
    <div class="body">
        <el-card class="box-card">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <h2 class="body-title">试题基本信息</h2>
                <el-row>
                    <el-col :span="6" class="pr20">
                        <el-form-item label="试题编号" prop="questionNo">
                            <el-input :disabled="$route.query.type == 'check'" v-model="form.questionNo"></el-input>
                        </el-form-item>
                    </el-col>
                    <!--          <el-col :span="6" class="pr20">-->
                    <!--            <el-form-item label="答题时限(秒)" prop="timeLimit">-->
                    <!--              <el-input-->
                    <!--                :disabled="$route.query.type == 'check'"-->
                    <!--                v-model="form.timeLimit"-->
                    <!--              ></el-input>-->
                    <!--            </el-form-item>-->
                    <!--          </el-col>-->
                    <el-col :span="6" class="pr20">
                        <el-form-item label="试题目录" prop="questionsDirectoryId">
                            <selectTree
                                :props="{
                                    value: 'id', // ID字段名
                                    label: 'directoryName', // 显示名称
                                    children: 'directoryList', // 子级字段名
                                }"
                                :options="catalogList"
                                :value="form.questionsDirectoryId"
                                :disabled="$route.query.type == 'check'"
                                @getValue="selectTreeChange"
                            ></selectTree>
                            <!-- <el-select
                :disabled="$route.query.type == 'check'"
                v-model="form.questionsDirectoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in catalogList"
                  :key="index"
                  :label="item.directoryName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="pr20">
                        <el-form-item label="试题类型" prop="questionType">
                            <el-select :disabled="$route.query.type == 'check'" v-model="form.questionType" placeholder="请选择">
                                <el-option v-for="(item, index) in questionTypeList" :key="index" :label="item.text" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6" class="pr20">
                        <el-form-item label="试题难度" prop="questionDifficulty">
                            <el-select :disabled="$route.query.type == 'check'" v-model="form.questionDifficulty" placeholder="请选择">
                                <el-option label="0" value="0"></el-option>
                                <el-option label="1" value="1"></el-option>
                                <el-option label="2" value="2"></el-option>
                                <el-option label="3" value="3"></el-option>
                                <el-option label="4" value="4"></el-option>
                                <el-option label="5" value="5"></el-option>
                                <el-option label="6" value="6"></el-option>
                                <el-option label="7" value="7"></el-option>
                                <el-option label="8" value="8"></el-option>
                                <el-option label="9" value="9"></el-option>
                                <el-option label="10" value="10"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!--          <el-col :span="6" class="pr20">-->
                    <!--            <el-form-item label="试题状态" prop="questionStatus">-->
                    <!--              <el-select-->
                    <!--                :disabled="$route.query.type == 'check'"-->
                    <!--                v-model="form.questionStatus"-->
                    <!--                placeholder-->
                    <!--              >-->
                    <!--                <el-option label="正常" value="0"></el-option>-->
                    <!--                <el-option label="不正常" value="1"></el-option>-->
                    <!--              </el-select>-->
                    <!--            </el-form-item>-->
                    <!--          </el-col>-->
                </el-row>

                <h2 class="body-title">试题内容</h2>
                <el-row>
                    <el-col :span="12" class="pr20">
                        <el-form-item label="题干内容" prop="questionStemContent">
                            <!--              <quillEditor-->
                            <!--                v-if="$route.query.type != 'check'"-->
                            <!--                v-model="form.questionStemContent"-->
                            <!--                ref="myQuillEditor"-->
                            <!--                :options="editorOption"-->
                            <!--              ></quillEditor>-->
                            <!--              <div v-else v-html="form.questionStemContent"></div>-->
                            <el-input :disabled="$route.query.type == 'check'" type="textarea" v-model="form.questionStemContent" placeholder></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="pr20">
                        <el-form-item label="试题分析" prop="questionAnalysis">
                            <!--              <quillEditor-->
                            <!--                v-if="$route.query.type != 'check'"-->
                            <!--                v-model="form.questionAnalysis"-->
                            <!--                ref="myQuillEditor"-->
                            <!--                :options="editorOption"-->
                            <!--              ></quillEditor>-->
                            <!--              <div v-else v-html="form.questionAnalysis"></div>-->
                            <el-input :disabled="$route.query.type == 'check'" type="textarea" v-model="form.questionAnalysis" placeholder></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <h2 class="body-title" v-show="form.questionType != ''">候选项</h2>
                <!-- 单选题 -->
                <el-table v-if="form.questionType == 1" class="mt20" :data="singleChoiceList" style="width: 100%">
                    <el-table-column label="选项" width="100px">
                        <template slot-scope="scope">
                            <span v-if="scope.$index == 0">A</span>
                            <span v-if="scope.$index == 1">B</span>
                            <span v-if="scope.$index == 2">C</span>
                            <span v-if="scope.$index == 3">D</span>
                            <span v-if="scope.$index == 4">E</span>
                            <span v-if="scope.$index == 5">F</span>
                            <el-checkbox :disabled="$route.query.type == 'check'" @change="singleChoiceCheckChange(scope.$index)" v-model="singleChoiceList[scope.$index].ischeck"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="内容">
                        <template slot-scope="scope">
                            <!--              <quillEditor-->
                            <!--                v-if="$route.query.type != 'check'"-->
                            <!--                v-model="singleChoiceList[scope.$index].content"-->
                            <!--                ref="myQuillEditor"-->
                            <!--                :options="editorOption"-->
                            <!--              ></quillEditor>-->
                            <!--              <div v-else v-html="singleChoiceList[scope.$index].content"></div>-->
                            <el-input :disabled="$route.query.type == 'check'" type="textarea" v-model="singleChoiceList[scope.$index].content" placeholder></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" v-if="$route.query.type == 'edit'">
                        <template slot-scope="scope">
                            <el-button v-if="scope.$index == 0" size="mini" type="primary" @click="addOption">添加</el-button>
                            <el-button size="mini" v-show="scope.$index > 0" type="danger" @click="delOption(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 多选题 -->
                <el-table v-if="form.questionType == 2" class="mt20" :data="multipleChoiceList" style="width: 100%">
                    <el-table-column label="选项" width="100px">
                        <template slot-scope="scope">
                            <span v-if="scope.$index == 0">A</span>
                            <span v-if="scope.$index == 1">B</span>
                            <span v-if="scope.$index == 2">C</span>
                            <span v-if="scope.$index == 3">D</span>
                            <span v-if="scope.$index == 4">E</span>
                            <span v-if="scope.$index == 5">F</span>
                            <el-checkbox :disabled="$route.query.type == 'check'" v-model="multipleChoiceList[scope.$index].ischeck"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="内容">
                        <template slot-scope="scope">
                            <!--              <quillEditor-->
                            <!--                v-if="$route.query.type != 'check'"-->
                            <!--                v-model="multipleChoiceList[scope.$index].content"-->
                            <!--                ref="myQuillEditor"-->
                            <!--                :options="editorOption"-->
                            <!--              ></quillEditor>-->
                            <!--              <div-->
                            <!--                v-else-->
                            <!--                v-html="multipleChoiceList[scope.$index].content"-->
                            <!--              ></div>-->
                            <el-input :disabled="$route.query.type == 'check'" type="textarea" v-model="multipleChoiceList[scope.$index].content" placeholder></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" v-if="$route.query.type == 'edit'">
                        <template slot-scope="scope">
                            <el-button v-if="scope.$index == 0" size="mini" type="primary" @click="addOption">添加</el-button>
                            <el-button size="mini" v-show="scope.$index > 0" type="danger" @click="delOption(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 判断题 -->
                <el-table v-if="form.questionType == 3" class="mt20" :data="trueFlaseList" style="width: 100%">
                    <el-table-column label="选项" width="100px">
                        <template slot-scope="scope">
                            <span v-if="scope.$index == 0">A</span>
                            <span v-if="scope.$index == 1">B</span>
                            <el-checkbox :disabled="$route.query.type == 'check'" @change="trueFlaseCheckChange(scope.$index)" v-model="trueFlaseList[scope.$index].ischeck"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="内容">
                        <template slot-scope="scope">
                            <!--              <quillEditor-->
                            <!--                v-if="$route.query.type != 'check'"-->
                            <!--                v-model="trueFlaseList[scope.$index].content"-->
                            <!--                ref="myQuillEditor"-->
                            <!--                :options="editorOption"-->
                            <!--              ></quillEditor>-->
                            <!--              <div v-else v-html="trueFlaseList[scope.$index].content"></div>-->
                            <el-input :disabled="$route.query.type == 'check'" type="textarea" v-model="trueFlaseList[scope.$index].content" placeholder></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" v-if="$route.query.type == 'edit'">
                        <template slot-scope="scope">
                            <el-button v-if="scope.$index == 0" size="mini" type="primary" @click="addOption">添加</el-button>
                            <el-button size="mini" v-show="scope.$index > 0" type="danger" @click="delOption(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="mb20"></div>
                <el-button v-if="$route.query.type == 'edit'" @click="save" type="primary" :loading="addLoading">保存</el-button>
                <el-button type="primary" @click="$router.back(-1)">返回</el-button>
            </el-form>
        </el-card>
    </div>
</template>

<script>
/**
questionNo：题库编号
timeLimit：答题时限
directoryName:试题目录
questionStatus：试题状态（0:正常 1:非正常）
questionDifficulty：试题难度
busiId：用户Id
questionStemContent:试题内容
questionAnalysis：试题分析
questionsDirectoryId：试题目录Id
trainingQuestionsAnswerDtos:答案集合
questionType:试题类型
 */
// require styles
import selectTree from "@/components/common/selectTree";
import "@/assets/css/quill.core.css";
import "@/assets/css/quill.snow.css";
import "@/assets/css/quill.bubble.css";

// import { quillEditor } from "vue-quill-editor";
// import { ImageDrop } from 'quill-image-drop-module'
// import ImageResize from 'quill-image-resize-module'
// Quill.register('modules/imageDrop', ImageDrop)
// Quill.register('modules/imageResize', ImageResize)
import exam from "@/api/mall/exam.js";
import Quill from "quill";
import { quillEditor } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
/*富文本编辑图片上传配置*/
const uploadConfig = {
    action: process.env.API_ROOT + "/clouddo-tranning/training/record/upload", // 必填参数 图片上传地址
    methods: "POST", // 必填参数 图片上传方式
    // token: window.localStorage.getItem("access-token"), // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
    name: "file", // 必填参数 文件的参数名
    size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
    accept: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon", // 可选 可上传的图片格式
};
// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [
    ["bold", "italic", "underline", "strike"],
    // ["blockquote", "code-block"],
    // [{ header: 1 }, { header: 2 }],
    // [{ list: "ordered" }, { list: "bullet" }],
    // [{ script: "sub" }, { script: "super" }],
    // [{ indent: "-1" }, { indent: "+1" }],
    // [{ direction: "rtl" }],
    // [{ size: ["small", false, "large", "huge"] }],
    // [{ header: [1, 2, 3, 4, 5, 6, false] }],
    // [{ color: [] }, { background: [] }],
    // [{ font: [] }],
    // [{ align: [] }],
    // ["clean"],
    ["image"],
];
const handlers = {
    image: function image() {
        var self = this;

        var fileInput = this.container.querySelector("input.ql-image[type=file]");
        if (fileInput === null) {
            fileInput = document.createElement("input");
            fileInput.setAttribute("type", "file");
            // 设置图片参数名
            if (uploadConfig.name) {
                fileInput.setAttribute("name", uploadConfig.name);
            }
            // 可设置上传图片的格式
            fileInput.setAttribute("accept", uploadConfig.accept);
            fileInput.classList.add("ql-image");
            // 监听选择文件
            fileInput.addEventListener("change", function() {
                // 创建formData
                var formData = new FormData();
                formData.append(uploadConfig.name, fileInput.files[0]);
                formData.append("object", "product");
                // 如果需要token且存在token
                if (uploadConfig.token) {
                    formData.append("token", uploadConfig.token);
                }
                // 图片上传
                var xhr = new XMLHttpRequest();
                xhr.open(uploadConfig.methods, uploadConfig.action, true);
                xhr.setRequestHeader("Authorization", window.localStorage.getItem("access-token"));
                // 上传数据成功，会触发
                xhr.onload = function(e) {
                    if (xhr.status === 200) {
                        var res = JSON.parse(xhr.responseText);
                        let length = self.quill.getSelection(true).index;
                        //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
                        console.log(res.data);
                        self.quill.insertEmbed(length, "image", "http://" + res.data);
                        self.quill.setSelection(length + 1);
                    }
                    fileInput.value = "";
                };
                // 开始上传数据
                xhr.upload.onloadstart = function(e) {
                    fileInput.value = "";
                };
                // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
                xhr.upload.onerror = function(e) {};
                // 上传数据完成（成功或者失败）时会触发
                xhr.upload.onloadend = function(e) {
                    // console.log('上传结束')
                };
                xhr.send(formData);
            });
            this.container.appendChild(fileInput);
        }
        fileInput.click();
    },
};
export default {
    components: {
        quillEditor,
        selectTree,
    },
    data() {
        return {
            selectCatalogue: {},
            editorOption: {
                //  富文本编辑器配置
                placeholder: "",
                theme: "snow", // 主题
                modules: {
                    // 新增下面
                    imageDrop: true, // 拖动加载图片组件。
                    imageResize: {
                        //调整大小组件。
                        displayStyles: {
                            backgroundColor: "black",
                            border: "none",
                            color: "white",
                        },
                        modules: ["Resize", "DisplaySize", "Toolbar"],
                    },
                    toolbar: {
                        container: toolOptions, // 工具栏选项
                        // handlers: handlers // 事件重写
                    },
                },
                history: {
                    delay: 1000,
                    maxStack: 50,
                    userOnly: false,
                },
                imageDrop: true,
                imageResize: {
                    displayStyles: {
                        backgroundColor: "black",
                        border: "none",
                        color: "white",
                    },
                    modules: ["Resize", "DisplaySize", "Toolbar"],
                },
            },
            questionTypeList: [],
            catalogList: [], // 试题目录
            form: {
                questionNo: undefined,
                timeLimit: 0,
                directoryName: undefined,
                questionStatus: "0",
                questionDifficulty: undefined,
                busiId: undefined,
                questionStemContent: undefined,
                questionAnalysis: undefined,
                questionsDirectoryId: undefined,
                questionType: undefined,
            },
            rules: {
                questionType: [{ required: true, message: "请选择试题类型", trigger: "change" }],
                questionNo: [{ required: true, message: "请输入试题编号", trigger: "blur" }],
                timeLimit: [{ required: true, message: "请输入答题限时（秒）", trigger: "blur" }],
                questionsDirectoryId: [{ required: true, message: "请选择试题目录", trigger: "change" }],
                questionStatus: [{ required: true, message: "请选择试题状态", trigger: "change" }],
                questionDifficulty: [{ required: true, message: "请选择试题难度", trigger: "change" }],
                questionStemContent: [{ required: true, message: "请输入题干内容", trigger: "blur" }],
            },
            singleChoiceList: [
                {
                    ischeck: false,
                    content: "",
                },
                {
                    ischeck: false,
                    content: "",
                },
                {
                    ischeck: false,
                    content: "",
                },
                {
                    ischeck: false,
                    content: "",
                },
            ],
            multipleChoiceList: [
                {
                    ischeck: false,
                    content: "",
                },
                {
                    ischeck: false,
                    content: "",
                },
                {
                    ischeck: false,
                    content: "",
                },
                {
                    ischeck: false,
                    content: "",
                },
            ],
            trueFlaseList: [
                {
                    ischeck: false,
                    content: "正确",
                },
                {
                    ischeck: false,
                    content: "错误",
                },
            ],
            addLoading: false,
        };
    },
    mounted() {
        this.questionTypeList = JSON.parse(localStorage.getItem("questionTypeList"));

        this.getCatalogList();
        // if (this.$route.query.type != "check") {
        //   this.editorOption.modules.toolbar.container[1] = ["image"];
        // }
        if (this.$route.query.id) {
            this.getQuestionBankDetail();
        }

        // window.addEventListener("paste", function(e) {
        //   var items,
        //     flag = false;
        //   //判断IE浏览器
        //   if (!!window.ActiveXObject || "ActiveXObject" in window) {
        //     items = window.clipboardData.files;
        //   } else {
        //     var cli = e.clipboardData || e.originalEvent.clipboardData;
        //     items = cli.items;
        //   }
        //   for (var i = 0, len = items.length; i < len; i++) {
        //     var item = items[i];
        //     //ie
        //     if (!!window.ActiveXObject || "ActiveXObject" in window) {
        //       if (item.type.indexOf("image/") > -1) {
        //         flag = true;
        //         break;
        //       }
        //     }
        //     //非ie
        //     else {
        //       if (item.kind === "string") {
        //         console.log("string");
        //         // item.getAsString(function (str) {
        //         // str 是获取到的字符串
        //         //  })
        //       } else if (item.kind === "file") {
        //         //有文件，则直接break
        //         console.log("file");
        //         flag = true;
        //         break;
        //         // var pasteFile = item.getAsFile();
        //         // pasteFile就是获取到的文件
        //       }
        //     }
        //   }
        //   if (flag) {
        //     alert("请不要粘贴图片");
        //     return false; // 终止粘贴操作
        //   }
        // });
    },
    methods: {
        selectTreeChange(v) {
            this.selectCatalogue = v;
            this.form.questionsDirectoryId = v.id;
        },
        getQuestionBankDetail() {
            exam.getQuestionBankDetail({
                questionId: this.$route.query.id,
            }).then((res) => {
                if (res.data.questionType == 1) {
                    let temp = [];
                    res.data.trainingQuestionsAnswers.forEach((v) => {
                        temp.push({
                            ischeck: v.trueStatus == 1 ? false : true,
                            content: v.quetionAnswer,
                        });
                    });
                    this.singleChoiceList = temp;
                }
                if (res.data.questionType == 2) {
                    let temp = [];
                    res.data.trainingQuestionsAnswers.forEach((v) => {
                        temp.push({
                            ischeck: v.trueStatus == 1 ? false : true,
                            content: v.quetionAnswer,
                        });
                    });
                    this.multipleChoiceList = temp;
                }
                if (res.data.questionType == 3) {
                    let temp = [];
                    res.data.trainingQuestionsAnswers.forEach((v) => {
                        temp.push({
                            ischeck: v.trueStatus == 1 ? false : true,
                            content: v.quetionAnswer,
                        });
                    });
                    this.trueFlaseList = temp;
                }
                delete res.data.trainingQuestionsAnswers;
                res.data.questionType = String(res.data.questionType);
                this.form = res.data;

                this.form.questionStatus = String(this.form.questionStatus);
                this.form.questionDifficulty = String(this.form.questionDifficulty);
            });
        },
        getCatalogList() {
            exam.getCatalogList({
                type: 1,
                // enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
                //   .enterpriseId
            }).then((res) => {
                this.catalogList = res.data;
            });
        },
        singleChoiceCheckChange() {
            this.singleChoiceList.forEach((v) => {
                v.ischeck = false;
            });
            this.singleChoiceList[arguments[0]].ischeck = true;
        },
        trueFlaseCheckChange() {
            this.trueFlaseList.forEach((v) => {
                v.ischeck = false;
            });
            this.trueFlaseList[arguments[0]].ischeck = true;
        },
        addOption() {
            if (this.form.questionType == 1) {
                if (this.singleChoiceList.length == 6) return;
                this.singleChoiceList.push({
                    ischeck: false,
                    content: "",
                });
            }
            if (this.form.questionType == 2) {
                if (this.multipleChoiceList.length == 6) return;
                this.multipleChoiceList.push({
                    ischeck: false,
                    content: "",
                });
            }
            if (this.form.questionType == 3) {
                if (this.trueFlaseList.length == 6) return;
                this.trueFlaseList.push({
                    ischeck: false,
                    content: "",
                });
            }
        },
        delOption(index) {
            if (this.form.questionType == 1) {
                if (this.singleChoiceList.length == 0) return;
                this.singleChoiceList.splice(index, 1);
            }
            if (this.form.questionType == 2) {
                if (this.multipleChoiceList.length == 0) return;
                this.multipleChoiceList.splice(index, 1);
            }
            if (this.form.questionType == 3) {
                if (this.trueFlaseList.length == 0) return;
                this.trueFlaseList.splice(index, 1);
            }
        },
        save() {
            if (this.form.questionType == 1) {
                this.singleChoiceList.some((v) => {});
                if (this.singleChoiceList.length < 2) {
                    this.$message.error("候选项必须大于等于2");
                    throw "候选项必须大于等于2";
                }
            }
            if (this.form.questionType == 2) {
                let num = 0;
                this.multipleChoiceList.some((v) => {
                    if (v.ischeck) {
                        num++;
                    }
                });
                if (num < 2) {
                    this.$message.error("多选题正确选项必须大于等于2个");
                    throw "多选题正确选项必须大于等于2个";
                }
                if (this.multipleChoiceList.length < 2) {
                    this.$message.error("候选项必须大于等于2");
                    throw "候选项必须大于等于2";
                }
            }
            if (this.form.questionType == 3) {
                if (this.trueFlaseList.length < 2) {
                    this.$message.error("候选项必须大于等于2");
                    throw "候选项必须大于等于2";
                }
            }

            this.$refs.form.validate((validate) => {
                if (validate == false) return;

                let p = {
                    ...this.form,
                    // enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
                    //   .enterpriseId
                };

                p.busiId = JSON.parse(localStorage.getItem("userinfo")).id;
                if (p.questionsDirectoryId) {
                    p.directoryName = this.selectCatalogue.text;
                }
                if (p.questionType == 1) {
                    let temp = [];
                    this.singleChoiceList.forEach((v) => {
                        temp.push({
                            quetionAnswer: v.content,
                            trueStatus: v.ischeck ? 0 : 1,
                        });
                    });
                    p.trainingQuestionsAnswerDtos = temp;
                }
                if (p.questionType == 2) {
                    let temp = [];
                    this.multipleChoiceList.forEach((v) => {
                        temp.push({
                            quetionAnswer: v.content,
                            trueStatus: v.ischeck ? 0 : 1,
                        });
                    });
                    p.trainingQuestionsAnswerDtos = temp;
                }
                if (p.questionType == 3) {
                    let temp = [];
                    this.trueFlaseList.forEach((v) => {
                        temp.push({
                            quetionAnswer: v.content,
                            trueStatus: v.ischeck ? 0 : 1,
                        });
                    });
                    p.trainingQuestionsAnswerDtos = temp;
                }
                console.log(p);
                if (this.$route.query.id) {
                    exam.updateLibrary(p).then((res) => {
                        if (res.code == 0) {
                            this.$message.success("成功");
                            this.$router.go(-1);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                    return;
                }
                this.addLoading = true;
                exam.addLibrary(p).then((res) => {
                    if (res.code == 0) {
                        this.$message.success("成功");
                        this.$router.go(-1);
                    } else {
                        this.addLoading = false;
                        this.$message.error(res.message);
                    }
                });
            });
        },
    },
    destroyed() {
        window.removeEventListener("paste");
    },
};
</script>

<style>
.body img {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/examination/addQuestion.vue